import {
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_APPEND,
  SET_QUERY,
  CLEAR_SEARCH,
} from "./types";
import axios from "axios";
import { apikey } from "../../apikey";

export const setQuery = (text) => ({
  type: SET_QUERY,
  payload: text,
});

export const clearSearch = () => ({
  type: CLEAR_SEARCH,
});

export const searchMovies = (query, page = 1) => async (dispatch) => {
  if (!query || query.trim().length < 3) {
    dispatch({
      type: SEARCH_FAILURE,
      payload: "Please enter at least 3 characters to search.",
    });
    return;
  }
  if (page === 1) {
    dispatch({ type: SEARCH_REQUEST });
  }
  try {
    const res = await axios.get(
      `https://www.omdbapi.com/?apikey=${apikey}&s=${query.trim()}&page=${page}`
    );
    if (res.data.Response === "True") {
      if (page === 1) {
        dispatch({
          type: SEARCH_SUCCESS,
          payload: {
            results: res.data.Search,
            totalResults: parseInt(res.data.totalResults),
            page,
          },
        });
      } else {
        dispatch({
          type: SEARCH_APPEND,
          payload: {
            results: res.data.Search,
            page,
          },
        });
      }
    } else {
      dispatch({
        type: SEARCH_FAILURE,
        payload: res.data.Error || "No results found",
      });
    }
  } catch (err) {
    dispatch({
      type: SEARCH_FAILURE,
      payload: "Failed to search. Please try again.",
    });
  }
};
